import React, { createContext, useContext, useState } from 'react'

import { DEFAULT_ENV } from '../pages/predactiv-admin/helpers'

const EnvironmentContext = createContext()

export function PDPEnvironmentProvider({ children, initial = DEFAULT_ENV }) {
  const [pdpEnvironment, setPDPEnvironment] = useState(initial)
  return (
    <EnvironmentContext.Provider value={{ pdpEnvironment, setPDPEnvironment }}>
      {children}
    </EnvironmentContext.Provider>
  )
}

export function usePDPEnvironment() {
  return useContext(EnvironmentContext)
}
